import React from "react";
import { Route, Switch } from "react-router-dom";
import Overview from "./overview/Overview";
import BelegeInbox from "./belege/BelegeInbox";
import Bank from "./bank/Bank";
import Receivables from "./receivables/Receivables";
import Recurring from "./recurring/Recurring";
import Suppliers from "./suppliers/Suppliers";
import Journal from "./journal/Journal";
import Tax from "./tax/Tax";
import PayrollRuns from "./payroll/PayrollRuns";
import AssetsAndCash from "./assets/AssetsAndCash";
import Reports from "./reports/Reports";
import Deadlines from "./deadlines/Deadlines";
import DatevExport from "./datev/DatevExport";
import Assistant from "./assistant/Assistant";
import Settings from "./settings/Settings";
import "./shared/accounting.css";

// All accounting pages live under /user/accounting/*, guarded once by the "Accounting" module
// permission in app-universal.jsx. Each module owns its folder; sub-routes (e.g. a Beleg's
// detail page) are matched inside the module's own component with the `match` prop.
const AccountingRouter = () => (
  <div className="acct-module">
    <Switch>
      <Route path="/user/accounting" exact component={Overview} />
      <Route path="/user/accounting/belege" component={BelegeInbox} />
      <Route path="/user/accounting/bank" component={Bank} />
      <Route path="/user/accounting/receivables" component={Receivables} />
      <Route path="/user/accounting/recurring" component={Recurring} />
      <Route path="/user/accounting/suppliers" component={Suppliers} />
      <Route path="/user/accounting/journal" component={Journal} />
      <Route path="/user/accounting/tax" component={Tax} />
      <Route path="/user/accounting/payroll" component={PayrollRuns} />
      <Route path="/user/accounting/assets" component={AssetsAndCash} />
      <Route path="/user/accounting/reports" component={Reports} />
      <Route path="/user/accounting/datev" component={DatevExport} />
      <Route path="/user/accounting/deadlines" component={Deadlines} />
      <Route path="/user/accounting/assistant" component={Assistant} />
      <Route path="/user/accounting/settings" component={Settings} />
    </Switch>
  </div>
);

export default AccountingRouter;
